import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from "@azure/msal-react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { msalInstance, initializeMsal } from "./msalConfig";
import './styles/msal.css'
import { AuthProvider } from "./AuthContext";

const rootElement = document.getElementById('root');

// Ensure the `rootElement` is not null
if (!rootElement) {
  throw new Error("Root element not found. Make sure there is a DOM element with id 'root'.");
}

const root = ReactDOM.createRoot(rootElement);

// Create a loading component
const LoadingApp = () => (
  <div className="loading-container">
    <h2>Loading application...</h2>
    <p>Initializing authentication services</p>
  </div>
);

// Main app wrapper that handles initialization
const AppWrapper = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    initializeMsal()
      .then(() => {
        console.log("MSAL initialization completed");
        setIsInitialized(true);
      })
      .catch(err => {
        console.error("Failed to initialize MSAL:", err);
        setError("Failed to initialize authentication. Please refresh the page.");
      });
  }, []);

  if (error) {
    return (
      <div className="error-container">
        <h1>Application Error</h1>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Refresh Page</button>
      </div>
    );
  }

  if (!isInitialized) {
    return <LoadingApp />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MsalProvider>
  );
};

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppWrapper />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
